// extracted by mini-css-extract-plugin
module.exports = {"stepperWrap":"_3Whmo","current":"_2tJ4d","ripple":"_20LU_","active":"_1LXAu","heading":"_2NH8B","subHeading":"Z17u1"};